import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { addWeeks } from "date-fns";
import { computed } from "vue";
import OrderSumBNPL from "./OrderSumBNPL.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderSumBNPLPodeli',
    props: {
        sum: { type: Number, required: true },
    },
    setup(__props) {
        const props = __props;
        const payments = computed(() => {
            let payments = [];
            for (let number = 1; number <= 4; number++) {
                payments.push({
                    amount: props.sum / 4,
                    date: addWeeks(new Date(), (number - 1) * 2),
                });
            }
            return payments;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(OrderSumBNPL, {
                payments: payments.value,
                "show-fractions": ""
            }, null, 8 /* PROPS */, ["payments"]));
        };
    }
});
